<template>
  <div v-if="!isSoldOut" class="main_container clear">
    <div class="bread_header">
      <a
        class="player_header_back"
        @click="$router.push({ name: 'MemberStudy' })"
        href="javascript:;"
      >
        我的课程
      </a>
      <span class="current">{{ course.title }}</span>
      <el-dropdown
        class="f-right lnk_user"
        v-if="user && user.avatar"
        @command="onStudentMenu"
      >
        <div
          class="lnk_login"
          @click="$router.push({ name: 'MemberCalendar' })"
        >
          <img class="avatar" :src="user.avatar" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="center">个人中心</el-dropdown-item>
          <el-dropdown-item command="MemberOrder">我的订单</el-dropdown-item>
          <el-dropdown-item command="MemberStudy">我的课程</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      class="player_container"
      :class="{ player_container_packup: player_container_packup == 1 }"
    >
      <div ref="videoWrap" id="video-wrap" class="video_left"></div>
      <div class="player_right">
        <div class="player_menu">
          <ul>
            <li class="player_menu_item" @click="menuUpdate(-1)">
              <div class="icon icon_sq"></div>
              <div class="text">
                {{ player_container_packup == 2 ? "收起" : "展开" }}
              </div>
            </li>
            <li
              class="player_menu_item"
              @click="menuUpdate(0)"
              :class="{ tabActive: tabActive == 0 }"
            >
              <div class="icon icon_menu"></div>
              <div class="text">目录</div>
            </li>
            <li
              class="player_menu_item"
              @click="menuUpdate(1)"
              :class="{ tabActive: tabActive == 1 }"
            >
              <div class="icon icon_data"></div>
              <div class="text">资料</div>
            </li>
            <li
              class="player_menu_item"
              @click="menuUpdate(2)"
              :class="{ tabActive: tabActive == 2 }"
            >
              <div class="icon icon_exam"></div>
              <div class="text">试卷</div>
            </li>
          </ul>
        </div>
        <div class="player_tabs">
          <div class="player_tab" v-show="tabActive == 0">
            <div class="player_tab_course">
              <div class="tab_course">
                <h1 class="w_bfb">{{ getCourseVideoInfo.title }}</h1>
                <div class="tab_course_comment w_bfb">
                  <el-rate
                    v-model="getCourseVideoInfo.grade_val"
                    :disabled="true"
                    class="f-left"
                  ></el-rate>
                  <div class="grade">
                    {{ getCourseVideoInfo.comment_grade }}分
                  </div>
                </div>
                <div
                  class="tab_course_name w_bfb eps"
                  v-if="getCourseVideoInfo.teachers.length > 0"
                >
                  讲师：
                  <span
                    v-for="(item, index) in getCourseVideoInfo.teachers"
                    :key="index"
                  >
                    <font v-if="index > 0">、</font>
                    {{ item.teacher_name }}
                  </span>
                </div>
              </div>
            </div>
            <div class="player_catalog_title">目录</div>
            <div class="player_catalog" id="catalog_body">
              <div class="schedule">
                <div class="w_bfb">
                  <div class="schedule_title">学习进度</div>
                  <div class="schedule_ksed">
                    已学习：
                    <span>{{ getCourseVideoInfo.progress_rate }}%</span>
                  </div>
                </div>
                <div class="schedule_line">
                  <div
                    class="schedule_lined"
                    :style="{ width: getCourseVideoInfo.progress_rate + '%' }"
                  ></div>
                </div>
              </div>
              <div class="player_catalog_count">
                课时列表 &nbsp; 已学习/总课时：
                {{ courseChapterTree.total.study_num }}/{{
                  courseChapterTree.total.total_num
                }}
              </div>
              <div
                class="w_bfb"
                v-if="
                  courseChapterTree.chapter &&
                  courseChapterTree.chapter.length > 0
                "
              >
                <VideoCourseChapter
                  @periodFiles="getChapterFile($event)"
                  ref="chapter"
                  :course="course"
                  :courseChapterDataList="courseChapterTree.chapter"
                  :currentPeriod="period_id"
                  :tryText="''"
                  :isVideo="true"
                  :onPeriodTap="onPeriodTap"
                ></VideoCourseChapter>
              </div>
            </div>
          </div>
          <div class="player_tab" v-show="tabActive == 1">
            <div class="tab_title">资料</div>
            <div class="player_tab_white_body">
              <div
                class="period_files"
                id="periodFiles"
                v-show="filesList.length > 0"
              >
                <div
                  v-for="(file, index) in filesList"
                  class="period_file_wrap"
                  :key="index"
                  :title="file.file_name"
                >
                  <div
                    class="period_file"
                    :title="file.file_name"
                    @click="onPreview(file)"
                  >
                    <img
                      :src="
                        require(`@/assets/images/course/${file.file_ext}-icon@2x.png`)
                      "
                      class="file_type"
                    />
                    <span class="eps">
                      {{ file.file_name }}
                    </span>
                    <span
                      v-if="file.ware_url"
                      class="classes_ware_file_download"
                      @click="onFileClick(file)"
                    >
                      下载
                    </span>
                  </div>
                </div>
              </div>
              <div class="empty" v-show="filesList.length == 0">暂无资料</div>
            </div>
          </div>
          <div class="player_tab" v-show="tabActive == 2">
            <div class="tab_title">试卷</div>
            <div class="player_tab_white_body">
              <div class="empty" v-if="courseGetTest.length == 0">暂无试卷</div>
              <div
                class="courseGetTest"
                v-show="courseGetTest.length > 0"
                id="courseGetTestBox"
              >
                <CourseExam
                  :courseId="course_id"
                  v-for="exam in courseGetTest"
                  labelPage="video"
                  :key="exam.id"
                  :exam="exam"
                ></CourseExam>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CourseSoldOut v-else></CourseSoldOut>
</template>
<script>
import CourseExam from "../../components/CourseExam.vue";

import VideoCourseChapter from "../../components/VideoCourseChapter.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";
import Vue from "vue";

export default {
  name: "Video",
  components: {
    VideoCourseChapter,
    CourseSoldOut,
    CourseExam,
  },
  data() {
    return {
      tabActive: 0,
      courseChapterTree: {
        total: { total_num: 0, study_num: 0 },
        chapter: [],
      },
      filesList: [],
      getCourseVideoInfo: {
        progress_rate: 0,
        title: "",
        grade_val: 0,
        comment_grade: 0,
        teachers: [],
      },
      courseGetTest: [],
      player_container_packup: 2,
      parent: this.$route.query.parent,
      course_type: "",
      course_id: "",
      period_id: "",
      video_id: "",
      course: {},
      timer: null,
      timesTimer: null,
      currentTime: 0,
      isSoldOut: false,
      isPlay: false,
      seconds: 0,
      player: null,
      user: {},
    };
  },
  async mounted() {
    this.$nextTick(async () => {
      this.$refs.videoWrap.addEventListener("contextmenu", event => {
        event.preventDefault();
      });
      await this.init();
      await this.newDetails();
      await this.play();
      $('#customerServerTip').css('display','none')//隐藏联系客服
    });
  },
  computed: {
    // 是否是会员
    isShowVipFree() {
      if (this.$store.state.token && this.course.vipData.is_vip_course == 1) {
        return true;
      }
      return false;
    },
  },
  async created() {
    this.user = await this.$http.get("/api/app/userInfo");
  },
  methods: {
    onFileClick(file) {
      if (!file.ware_url) {
        return;
      }
      window.open(file.ware_url);
    },
    async onPreview(file) {
      if (!this.course.is_buy && !this.isShowVipFree) {
        return this.$info("请您先报名");
      }
      if (file.file_ext == "mp3" || file.file_ext == "mp4") {
        let data = await this.$http.get(
          "/api/app/user/CourseWare/video/preview",
          {
            video_id: file.fid,
          },
        );
        window.open(data[0].url);
      } else {
        let data = await this.$http.get("/api/app/user/CourseWare/preview", {
          fid: file.fid,
        });
        window.open(data);
      }
    },
    getChapterFile(files) {
      this.filesList = files;
      window.$(window).resize(function () {
        window.$("#periodFiles").height(window.innerHeight - 110);
        window.$("#courseGetTestBox").height(window.innerHeight - 110);
      });
      window.$("#periodFiles").height(window.innerHeight - 110);
      window.$("#courseGetTestBox").height(window.innerHeight - 110);
    },
    async newDetails() {
      let $catalogBody = window.$("#catalog_body");
      window.$(window).resize(function () {
        $catalogBody.height(
          window.innerHeight - $catalogBody.offset().top - 10,
        );
      });
      $catalogBody.height(window.innerHeight - $catalogBody.offset().top - 10);
      this.courseGetTest = await this.$http.get(
        "/api/app/course/getTest/" + this.course_id,
      );
      this.courseChapterTree = await this.$http.post(
        "/api/app/courseChapterTree",
        {
          id: this.course_id,
        },
      );
      let getCourseVideoInfo = await this.$http.get(
        "/api/app/course/getCourseVideoInfo/" + this.course_id,
      );
      getCourseVideoInfo.grade_val = parseInt(getCourseVideoInfo.comment_grade);
      this.getCourseVideoInfo = getCourseVideoInfo;
      this.$refs.chapter.getData();
    },
    menuUpdate(index) {
      if (index == -1) {
        this.player_container_packup =
          this.player_container_packup == 1 ? 2 : 1;
        return;
      }
      this.tabActive = index;
    },
    onStudentMenu(command) {
      let that = this;
      console.log(command);
      switch (command) {
        case "center":
          that.$router.push({ name: "MemberCalendar" });
          break;
        case "MemberOrder":
          that.$router.push({ name: "MemberOrder" });
          break;
        case "MemberStudy":
          that.$router.push({ name: "MemberStudy" });
          break;
      }
    },
    async init() {
      this.clearTimer();
      this.isPlay = false;
      this.course_id = parseInt(this.$route.query.course_id);
      this.course_type = this.$route.query.course_type;
      this.period_id = this.$route.query.period_id.toString();
      this.video_id = this.$route.query.video_id;
      this.parent = this.$route.query.parent;
      let data = await this.$http.get(
        "/api/app/courseInfo/basis_id=" + this.course_id,
        {},
        {
          onError: data => {
            if (data.msg == "你来晚了，该课程已下架") {
              this.isSoldOut = true;
            }
          },
        },
      );
      this.course = data.info;
      this.timesTimer = setInterval(() => {
        if (!this.isPlay) {
          return;
        }
        this.seconds++;
      }, 1000);
    },
    clearTimer() {
      if (this.timesTimer) {
        clearInterval(this.timesTimer);
        this.timesTimer = null;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    async timerFuc() {
      let current_time = this.seconds;
      this.seconds = 0;
      await this.$http.post(
        "/api/app/remember/video/time_new",
        {
          chapter_id: this.period_id,
          time: this.currentTime,
          current_time: current_time,
        },
        { showLoading: false },
      );
    },
    initTimer() {
      this.timer = setTimeout(async () => {
        await this.timerFuc();
        if (!this.isPlay) {
          return;
        }
        this.initTimer();
      }, 5000);
    },
    async playNext() {
      let period = this.$refs.chapter.getNextPeriod(this.period_id);
      if (!period || (period.periods_type != 5 && period.periods_type != 8)) {
        return;
      }
      await this.$services.CourseService.watchVideo(
        period,
        this.course_type,
        this.course_id,
      );
      setTimeout(() => {
        if (Vue.config.bjy_player) {
          Vue.config.bjy_player.play();
        }
      }, 6000);
    },
    async play() {
      if (this.course_type != 5 && this.course_type != 8) {
        return;
      }
      if (this.video_id == "") {
        return;
      }
      let course_setting = (
        await this.$http.get("/api/app/config/course_setting")
      ).course_setting;
      let dataTime = await this.$http.get(
        "/api/app/video/time/" + this.period_id,
      );
      let params = {};
      if (this.parent) {
        params.system_course_id = this.parent;
      }
      let data = await this.$http.get(
        "/api/app/getPlayToken/chapter_id=" +
          this.period_id +
          "/course_id=" +
          this.course_id,
        params,
      );
      // 是否允许控制播放
      const allowControlPlay = data.double_speed_play == 1;
      Vue.config.bjy_player = new window.BPlayer({
        container: document.getElementById("video-wrap"), // 设置播放器初始化的父容器
        token: data.token,
        memory: true, //记忆播放
        useFFplayerMSE: true, //电流声改变
        vid: data.video_id,
        currentTime: dataTime,
        loop: course_setting.recorded_response_event == 3,
        enableDrag: allowControlPlay, // 是否允许拖拽进度条
        rateList: allowControlPlay ? [0.5, 0.75, 1, 1.25, 1.5,1.75, 2] : [], // 倍速列表
        user: {
          name: this.user.nickname, // 观看的学员用户名
          number: this.user.id, // 观看的学员number
        },
      });
      const eventTypes = {
        PLAY: "play", // 首次播放
        PLAYING: "playing", // 暂停后播放
        PAUSE: "pause", // 暂停
        SEEKING: "seeking", // 快进快退中
        WAITING: "waiting", // 加载中
        SEEKED: "seeked", // 快进快退结束
        ENDED: "ended", // 播放结束
        VOLUME_CHANGE: "volume_change", // 音量变化
        RATE_CHANGE: "rate_change", // 倍速变化
        ERROR: "error", // 播放出错
        TIMEUPDATE: "timeupdate", // 播放进度更新
        LOADEDMETADATA: "loadedmetadata", //
        QUALITY_CHANGE: "quality_change", // 切换清晰度
        ENDED_AD: "ended_ad", // 广告结束
        FULLSCREEN_CHANGE: "full_screen_change", // 全屏/退出全屏
      };
      // 监听首次播放事件
      Vue.config.bjy_player.on(eventTypes.PLAY, () => {
        this.isPlay = true;
        this.initTimer();
      });
      Vue.config.bjy_player.on(eventTypes.PLAYING, () => {
        if (this.isPlay == false) {
          this.isPlay = true;
          this.initTimer();
        }
      });
      // 暂停
      Vue.config.bjy_player.on(eventTypes.PAUSE, () => {
        this.isPlay = false;
      });
      // 进度条更新
      Vue.config.bjy_player.on(eventTypes.TIMEUPDATE, time => {
        this.currentTime = time;
      });
      // 结束
      Vue.config.bjy_player.on(eventTypes.ENDED, async () => {
        this.isPlay = false;
      });
    },
    onPeriodTap() {
      if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
        Vue.config.bjy_player.pause();
      }
    },
  },
  watch: {
    $route: async function () {
      if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
        Vue.config.bjy_player.pause();
        Vue.config.bjy_player.destroy();
      }
      await this.newDetails();
      await this.init();
      await this.play();
    },
  },
  destroyed() {
    if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
      Vue.config.bjy_player.pause();
      Vue.config.bjy_player.destroy();
    }
    window.$("#video-wrap").html("");
    this.isPlay = false;
    this.clearTimer();
    $('#customerServerTip').css('display','block')//销毁前显示客服
  },
};
</script>
<style lang="scss" scoped>
.main_container {
  background: #000;
  height: 100vh;
  .bread_header {
    width: 100%;
    float: left;
    height: 66px;
    line-height: 66px;
    background: #282828;
    position: relative;
    z-index: 111;
    .lnk_user {
      margin-right: 20px;
      .lnk_login {
        width: 36px;
        height: 36px;
        margin-top: 14px;
        .avatar {
          width: 100%;
          display: block;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }
    }

    .current {
      font-size: 16px;
      color: #fff;
      float: left;
      padding-left: 10px;
    }
    .player_header_back {
      height: 34px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-left: 0px;
      line-height: 34px;
      border-radius: 0 20px 20px 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      padding: 0 25px 0 30px;
      transition: 0.3s;
      cursor: pointer;
      float: left;
      position: relative;
      margin-top: 15px;
      margin-left: 0px;
    }
    .player_header_back::before {
      content: "";
      width: 20px;
      height: 20px;
      background: url(~@/assets/images/video/icons.png);
      background-position: -9px -57px;
      position: absolute;
      left: 10px;
      top: 50%;
      margin-top: -10px;
      opacity: 0.6;
    }
    .player_header_back:hover {
      background-color: rgba(255, 255, 255, 0.06);
    }
  }
  .player_container {
    height: calc(100vh - 66px);
    min-height: 500px;
    background: #000;
    position: relative;
    padding-right: 470px;
    overflow: hidden;
    transition: 0.3s;
    .video_left {
      height: 100%;
    }
    .player_right {
      position: absolute;
      width: 470px;
      right: 0;
      top: 0;
      height: 100%;
      background-color: #191919;
      box-sizing: border-box;
      padding-left: 61px;
      transition: 0.3s;
      .player_tabs,
      .player_tab {
        position: relative;
        height: 100%;
        width: 410px;
        display: table;
        .player_tab_course {
          padding: 15px;
          width: 375px;
          float: left;
          .tab_course {
            background: #282828;
            overflow: hidden;
            border-radius: 6px;
            padding: 15px;
            color: #fff;
            width: 100%;
            float: left;
            box-sizing: border-box;
            h1 {
              font-size: 14px;
              margin: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              line-height: 21px;
              max-height: 42px;
              cursor: pointer;
            }
            .tab_course_comment {
              overflow: hidden;
              line-height: 14px;
              padding: 8px 0;
              .grade {
                float: left;
                font-size: 12px;
                margin-left: 5px;
                line-height: 20px;
                color: rgba(255, 255, 255, 0.6);
              }
            }
            .tab_course_name {
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }
        .player_catalog_title {
          font-size: 16px;
          color: #fff;
          line-height: 36px;
          padding: 0px 20px;
          width: 100%;
          float: left;
          box-sizing: border-box;
        }
        .player_catalog {
          width: 410px;
          float: left;
          box-sizing: border-box;
          overflow-y: auto;
          height: calc(100% - 340px);
          overflow-x: hidden;
          .schedule {
            border: 1px solid #3b3b3b;
            margin: 10px 15px 0 15px;
            padding: 0px;
            background: #282828;
            /*
            background: url(~@/assets/images/video/img_bg.png) no-repeat;
            background-size: 100% 100%;
            */
            color: #fff;
            position: relative;
            height: 66px;
            float: left;
            width: 375px;
            box-sizing: border-box;
            .schedule_title {
              line-height: 20px;
              margin-top: 10px;
              float: left;
              margin-left: 15px;
            }
            .schedule_line {
              height: 6px;
              background: #868686;
              border-radius: 20px;
              position: relative;
              margin-top: 10px;
              margin-left: 15px;
              float: left;
              width: calc(100% - 30px);
              .schedule_lined {
                border-radius: 20px;
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                transition: width 1s;
                background-color: #f25130;
              }
            }
            .schedule_ksed {
              float: right;
              margin-right: 15px;
              line-height: 20px;
              margin-top: 10px;
              color: rgba(255, 255, 255, 0.5);
              span {
                color: #ea5a3c;
              }
            }
          }
          .player_catalog_count {
            line-height: 40px;
            color: rgba(255, 255, 255, 0.4);
            padding: 0 20px;
            float: left;
            width: 100%;
            box-sizing: border-box;
          }
        }
        /*滚动条样式*/
        .player_catalog::-webkit-scrollbar {
          width: 7px;
        }

        .player_catalog::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.4);
        }
        .player_catalog::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
        }
        .tab_title {
          height: 44px;
          line-height: 44px;
          background-color: #eee;
          padding: 0 20px;
          border-bottom: 1px solid #e3e3e3;
          font-size: 15px;
        }
        .player_tab_white_body {
          background-color: #fff;
          position: relative;
          box-sizing: border-box;
          width: 100%;
          float: left;
          .empty {
            text-align: center;
            font-size: 14px;
            color: #bbb;
            width: 100%;
            padding: 150px 0px 40px 0px;
            line-height: 24px;
            height: calc(100vh - 300px);
            float: left;
            background: #fff url(~@/assets/images/video/empty1.png) no-repeat
              50% 40px;
          }
          .courseGetTest {
            width: 100%;
            float: left;
            overflow-y: auto;
            overflow-x: hidden;
          }
          /*滚动条样式*/
          .courseGetTest::-webkit-scrollbar {
            width: 7px;
          }

          .courseGetTest::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: rgba(51, 51, 51, 0.4);
          }
          .courseGetTest::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 10px;
            background: rgba(51, 51, 51, 0.1);
          }
          .period_files {
            width: 100%;
            float: left;
            overflow-y: auto;
            overflow-x: hidden;
            .period_file_wrap {
              padding: 5px 15px;
              box-sizing: border-box;
              border-bottom: 1px dashed #e9e9e9;
              width: 100%;
              float: left;
              &:first-child {
                margin-top: 15px;
              }
              .period_file {
                cursor: pointer;
                float: left;
                width: 100%;
                color: #333333;
                .file_type {
                  height: 20px;
                  margin-right: 6px;
                  float: left;
                  margin-top: 6px;
                }
                span {
                  height: 32px;
                  line-height: 32px;
                  font-size: 14px;
                }
                .eps {
                  float: left;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 300px;
                }
                .classes_ware_file_download {
                  float: right;
                }
              }
              .period_file:hover {
                color: $primary-color;
              }
            }
          }
          /*滚动条样式*/
          .period_files::-webkit-scrollbar {
            width: 7px;
          }

          .period_files::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: rgba(51, 51, 51, 0.4);
          }
          .period_files::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 10px;
            background: rgba(51, 51, 51, 0.1);
          }
        }
      }
      .player_menu {
        width: 60px;
        position: absolute;
        left: 0;
        top: 0;
        border-right: 1px solid #000;
        height: 100%;
        background: url(~@/assets/images/video/menubg.png) repeat-y;
      }
      .player_menu ul {
        position: absolute;
        left: 0;
        width: 100%;
        top: 50%;
        margin-top: -200px;
      }
      .player_menu_item {
        width: 60px;
        height: 67px;
        text-align: center;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        padding-top: 12px;
        box-sizing: border-box;
        border-bottom: 1px solid #242424;
      }
      .tabActive {
        background: #26292c;
        color: #fff;
      }
      .tabActive .icon {
        opacity: 1 !important;
      }
      .player_menu .icon {
        width: 20px;
        height: 20px;
        margin: 0 auto;
        background-image: url(~@/assets/images/video/icons.png);
        background-repeat: no-repeat;
        opacity: 0.6;
      }
      .player_menu .icon_menu {
        background-position: -4px -102px;
      }
      .player_menu .icon_talk {
        background-position: -4px -185px;
      }
      .player_menu .icon_data {
        background-position: -4px -225px;
      }
      .player_menu .icon_notes {
        background-position: -73px -164px;
      }
      .player_menu .icon_exam {
        background-position: -73px -133px;
      }
      .player_menu .icon_sq {
        background-position: -73px -103px;
      }
      .player_menu .text {
        line-height: 28px;
      }
    }
  }
  .player_container_packup {
    padding-right: 60px;
    .player_menu .icon_sq {
      background-position: -111px -103px !important;
    }
    .player_right {
      right: -410px;
    }
  }
}
</style>
